var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 38,
    fill: "url(#paint0_linear_159_1983)",
    stroke: "#0B79B3",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.12 56V32.192H31.176V56H24.12ZM27.624 28.688C26.44 28.688 25.48 28.352 24.744 27.68C24.008 27.008 23.64 26.112 23.64 24.992C23.64 23.872 24.008 22.976 24.744 22.304C25.48 21.632 26.44 21.296 27.624 21.296C28.808 21.296 29.768 21.632 30.504 22.304C31.24 22.976 31.608 23.872 31.608 24.992C31.608 26.112 31.24 27.008 30.504 27.68C29.768 28.352 28.808 28.688 27.624 28.688ZM37.4325 56V32.192H43.1925L43.6725 35.216H43.8645C44.8565 34.224 45.9765 33.376 47.2245 32.672C48.4725 31.968 49.8965 31.616 51.4965 31.616C54.1205 31.616 56.0085 32.48 57.1605 34.208C58.3125 35.904 58.8885 38.24 58.8885 41.216V56H51.8325V42.128C51.8325 40.4 51.5925 39.216 51.1125 38.576C50.6645 37.936 49.9285 37.616 48.9045 37.616C48.0085 37.616 47.2405 37.824 46.6005 38.24C45.9605 38.624 45.2565 39.184 44.4885 39.92V56H37.4325Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_159_1983",
    x1: -36,
    y1: -14.5,
    x2: 125,
    y2: 93.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#148CCB",
    stopOpacity: 0.65
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c5eb75a7bb44bdabe92c9e42a4c7f116.svg";
export { ForwardRef as ReactComponent };